import { createGlobalStyle } from 'styled-components'

import theme, { breakpoint, containerWidth } from 'style/theme'

export default createGlobalStyle`
body {
  #__next {
    height: 100%;
  }
  .ant-typography,
  span {
    font-weight: normal;
    font-size: 14px;
  }
  .ant-typography,
  .ant-typography + h1.ant-typography,
  .ant-typography + h2.ant-typography,
  .ant-typography + h3.ant-typography,
  .ant-typography + h4.ant-typography,
  .ant-typography + h5.ant-typography {
    margin: 0;
    padding: 0;
  }
  h1, h1.ant-typography {
    font-size: 38px;
    margin: 0;
    padding: 0;
    @media (max-width: ${breakpoint.md}){
      font-size: 26px;
    }
  }
  h2, h2.ant-typography {
    font-size: 32px;
    margin: 0;
    padding: 0;
    @media (max-width: ${breakpoint.md}){
      font-size: 26px;
    }
  }
  h3, h3.ant-typography {
    font-size: 22px;
    margin: 0;
    padding: 0;
    @media (max-width: ${breakpoint.md}){
      font-size: 18px;
    }
  }
  h4, h4.ant-typography {
    font-size: 20px;
    margin: 0;
    padding: 0;
    @media (max-width: ${breakpoint.md}){
      font-size: 16px;
    }
  }
  h5, h5.ant-typography {
    font-size: 16px;
    margin: 0;
    padding: 0;
  }
  h1, h2, h3, h4, h5 {
    margin-top: 0;
    margin-bottom: 0.5em;
  }
  .font-size-small {
    font-size: 12px;
  }
  .font-size-medium {
    /* font-size: 50px; */
    font-size: 16px;
  }
  .font-medium {
    font-family: 'Kanit-Medium';
  }
  .font-semibold {
    font-family: 'Kanit-SemiBold';
  }
  .font-bold {
    font-family: 'Kanit-Bold';
  }
  div.ant-typography {
    margin: 0;
    padding: 0;
  }
  a {
    &:hover {
      color: ${theme.primaryRed};
    }
  }
  .ant-btn-primary {
    border-color: ${theme.primaryRed};
    background: ${theme.primaryRed};
  }
  .ant-btn-primary:hover, .ant-btn-primary:focus {
    border-color: ${theme.primaryRed};
    background: ${theme.primaryRed};
  }

  .container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    @media (min-width: ${breakpoint.sm}){
      max-width: ${containerWidth.sm};
    }
    @media (min-width: ${breakpoint.md}){
      max-width: ${containerWidth.md};
    }
    @media (min-width: ${breakpoint.lg}){
      max-width: ${containerWidth.lg};
    }
    @media (min-width: ${breakpoint.xl}){
      max-width: ${containerWidth.xl};
    }
    @media (min-width: ${breakpoint.xxl}){
      max-width: ${containerWidth.xxl};
    }
  }

  .render-desktop-md {
    @media (max-width: ${breakpoint.md}) {
      display: none;
    }
  }
  .render-mobile-md {
    @media (min-width: ${breakpoint.md}) {
      display: none;
    }
  }
  .render-desktop-lg {
    @media (max-width: ${breakpoint.lg}) {
      display: none;
    }
  }
  .render-mobile-lg {
    @media (min-width: ${breakpoint.lg}) {
      display: none;
    }
  }

  .dropdowm-custom {
    overflow: hidden;
    border-radius: 10px;
    box-shadow: 0 0 20px 0 rgba(134, 134, 134, 0.4);
    background: ${theme.white}; 
      .ant-dropdown-menu {
        padding: 10px;
      .ant-dropdown-menu-item {
        padding: 10px 20px;
      }
    }
  }

  .filter-booking-dropdown {
    width: 350px;
    .menu-title-block {
      padding: 10px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .ant-typography {
        cursor: pointer;
      }
      .text-reset {
        color: ${theme.primaryRed};
      }
    }

    .filter-item {
      .ant-dropdown-menu-title-content {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .filter-icon {
          display: flex;
          align-items: center;
          margin-right: 5px;
        }
      }

      &:not(:last-child) {
        .ant-dropdown-menu-title-content { 
          padding-bottom: 10px;
          border-bottom: 1px solid ${theme.lightGray};
        }
      }
    }
  }

  .ant-select-item-group {
    font-size: 14px;
  }

  .ant-select-item-option-selected {
    background-color: #fff0e2 !important;
  }

  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner,
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox-checked::after {
    border-color: ${theme.primaryRed};
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${theme.primaryRed};
    border-color: ${theme.primaryRed};
  }

  .ant-modal-confirm-btns {
    .ant-btn-default {
      &:hover, &:focus {
        color: rgba(0, 0, 0, 0.85);
        border-color: #d9d9d9;
      }
    }
  }
  .content-map-register {
    height: 900px;
    width: 100%;
    padding-top: 5px !important;
    padding-bottom: 20px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  .pt-20 {
    padding-top: 20px;
  }
  .pb-5 {
    padding-bottom: 5px;
  }
  .pb-10 {
    padding-bottom: 10px;
  }
  .pd-10 {
    padding: 10px;
  }
  .m-auto {
    margin: auto;
  }
  .custom-cb-images {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .pd-img{
    padding: 5px 0 5px 0;
  }
  .images-opacity-3 {
    transition : 0.5s;
    opacity: 0.3;

  }
  .image-opacity-1 {
    transition : 0.5s;
    opacity: 1;
  }
  .description-under-cb-img {
    padding-bottom: 10px;
    margin-top: 5px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    text-align: center;
  }
  .pd-button-modal-summary-fixer {
    width: 200px;
    margin: auto;
  }
  .container-button {
    display: flex;
    button {
      width: 200px !important;
      margin: 10px !important;

      @media (max-width: ${breakpoint.sm}) {
        width: 100% !important;
      }
    }
    @media (max-width: ${breakpoint.sm}) {
      display: unset;
    }
  }

  .ant-form-item{
    margin-bottom: 15px !important;
  }

}
`
